var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l(([1, 2]),function(item){return _c('div',{key:item.index,staticClass:"mb-5"},[_c('div',{staticClass:"loader loader-titles"}),_c('div',{staticClass:"d-flex loader-item flex-wrap my-3"},_vm._l(([1, 2, 3, 4]),function(item){return _c('div',{key:item.index,staticClass:"loader loader-card mx-3 mt-3"})}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }